import React from 'react';
import { useState } from 'react';
import Swal from 'sweetalert2';
import { upload } from '../../api/sportaloka-client';

const SingleImageUploader = ({
  accept,
  path,
  onChange,
  id,
  value,
  label,
  description,
  isError,
  errorMessage,
  disabled,
  required
}) => {
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    e.target.value = '';
    if (selectedFile) {
      handleUpload(selectedFile);
    }
  };

  const handleUpload = async (file) => {
    if (!file) {
      Swal.fire({
        title: 'Gagal!',
        text: `Harap memilih file`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('path', path);

    try {
      setLoading(true);
      const response = await upload(formData);
      onChange(response.data.data.url);
      setLoading(false);
    } catch (error) {
      Swal.fire({
        title: 'Gagal!',
        text: `Periksa koneksi internet anda dan coba kembali`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    }
  };

  const handleRemove = () => {
    onChange('');
  };

  return (
    <div className="form-group">
      <label>
        {label ? label : 'Upload Gambar'}{' '}
        {required && <span className="text-danger fw-600">*</span>}
      </label>
      <div
        className={`banner-uploader d-flex justify-content-center align-items-center 
          ${isError && 'border-danger'}
          ${disabled && 'opacity-50'}
          `}>
        <input
          disabled={disabled}
          accept={accept ? accept : '*'}
          type="file"
          onChange={handleFileChange}
          style={{ display: 'none' }}
          id={id}
        />
        {value && value !== '' && !loading && (
          <div className="d-flex flex-column position-relative">
            <img className="img-fluid" style={{ maxHeight: 320 }} src={value} alt="primary-image" />
            <button type="button" onClick={handleRemove} className="banner-uploader__delete">
              <i className="fa fa-close"></i>
            </button>
          </div>
        )}
        {!value && !loading && (
          <button
            type="button"
            disabled={loading || disabled}
            onClick={() => document.getElementById(id).click()}>
            <div className="icon-upload-file text-80 text-blue-1 mb-10"></div>
            <p className="fw-600 text-blue-1">Upload Gambar</p>
            {description && <p className="text-14">{description}</p>}
          </button>
        )}
        {loading && <p className="fw-500">Mengupload...</p>}
      </div>
      {isError && errorMessage && <span className="text-danger text-15">{errorMessage}</span>}
    </div>
  );
};

export default SingleImageUploader;
